var makeVariant = function makeVariant(_ref) {
  var theme = _ref.theme,
      variant = _ref.variant,
      type = _ref.type,
      state = _ref.state;
  return "color: ".concat(theme.links.variant[variant][type][state].color, "!important;\n          border-color: ").concat(theme.links.variant[variant][type][state].borderColor, ";\n          background-color: ").concat(theme.links.variant[variant][type][state].backgroundColor, ";\n          text-decoration: none;\n          outline: ").concat(theme.links.variant[variant][type][state].outline, " solid 1px;\n          \n          i {\n            &:before{\n              background-color: ").concat(theme.links.variant[variant][type][state].color, "!important;\n            }\n          }");
};

var getLinkSize = function getLinkSize(_ref2) {
  var theme = _ref2.theme,
      icon = _ref2.icon,
      size = _ref2.size;
  return icon && icon.size ? "".concat(icon.size, "px") : theme.links.size[size].withoutText;
};

var getLinkPadding = function getLinkPadding(_ref3) {
  var content = _ref3.content;
  return content ? '0px 12px' : '0';
};

var makeLink = function makeLink(_ref4) {
  var theme = _ref4.theme,
      linkoptions = _ref4.linkoptions,
      content = _ref4.content,
      icon = _ref4.icon;
  var size = linkoptions && linkoptions.size || 'small';
  var type = linkoptions && linkoptions.type || 'link';
  var variant = linkoptions && linkoptions.variant || 'primary';
  var block = linkoptions && linkoptions.block || false;
  var position = icon && icon.position || 'center';
  var paddingByIcon = {
    large: '60px',
    medium: '42px',
    small: '34px'
  };
  var padding = {
    right: "0 ".concat(paddingByIcon[size], " 0 8px"),
    left: "0 8px 0 ".concat(paddingByIcon[size]),
    center: "0 8px 0 8px"
  };
  return "\n    position: relative;\n    border: 1px solid transparent;\n    border-radius: 8px;\n    font-weight: 600;\n    transition: all .2s ease-in-out;\n    cursor: pointer;\n    display: ".concat(block ? "block" : "inline-block", ";\n    text-align: center;\n    padding: ").concat(icon && content ? padding[icon.position] : getLinkPadding({
    content: content
  }), ";\n    font-size: ").concat(theme.links.size[size].fontSize, ";\n    line-height: ").concat(theme.links.size[size].lineHeight, ";\n    height: ").concat(content ? "auto" : getLinkSize({
    theme: theme,
    icon: icon,
    size: size
  }), ";\n    width: ").concat(content ? "auto" : getLinkSize({
    theme: theme,
    icon: icon,
    size: size
  }), ";\n    ").concat(block ? "width: 100%!important;" : "", "\n    ").concat(makeVariant({
    theme: theme,
    variant: variant,
    type: type,
    state: 'idle'
  }), "\n    &:hover {\n      ").concat(makeVariant({
    theme: theme,
    variant: variant,
    type: type,
    state: 'hover'
  }), "\n    }\n    &:active {\n      ").concat(makeVariant({
    theme: theme,
    variant: variant,
    type: type,
    state: 'active'
  }), "\n    }\n    &:focus:not(:active) {\n      ").concat(makeVariant({
    theme: theme,
    variant: variant,
    type: type,
    state: 'focus'
  }), "\n    }\n    &:disabled, \n    &:disabled:hover,\n    &:disabled:active,\n    &:disabled:focus{\n      cursor: not-allowed;\n      ").concat(makeVariant({
    theme: theme,
    variant: variant,
    type: type,
    state: 'disabled'
  }), "\n    }");
};

export var makeLinkIcon = function makeLinkIcon(_ref5) {
  var _ref5$position = _ref5.position,
      position = _ref5$position === void 0 ? 'left' : _ref5$position,
      content = _ref5.content,
      linkoptions = _ref5.linkoptions;
  var size = linkoptions.size;
  var positionSize = {
    large: '15px',
    medium: '14px',
    small: '9px'
  };
  var iconSize = {
    large: '30px',
    medium: '24px',
    small: '18px'
  };
  var distance = !content || content === '' ? '50%' : positionSize[size];
  return "\n      position: absolute;\n      ".concat(position, ": ").concat(distance, ";\n      top: 50%;\n      transform: translate(").concat(!content || content === '' ? '-50%' : '0', ", -50%);  \n      width: ").concat(iconSize[size], ";\n      height: ").concat(iconSize[size], ";\n\n      &:before{\n        width: ").concat(iconSize[size], ";\n        height: ").concat(iconSize[size], ";\n      }");
};
export var makeNativeLink = function makeNativeLink(props) {
  return makeLink(props);
};
export var makeNotNativeLink = function makeNotNativeLink(props) {
  return makeLink(props);
};
export var makeNoFollowLink = function makeNoFollowLink(props) {
  return makeLink(props);
};
export var makeDisabledLink = function makeDisabledLink(props) {
  return makeLink(props);
};
export var makeAnchorLink = function makeAnchorLink(props) {
  return makeLink(props);
};